/**
 * Cluster 5 · Will you enjoy it?
 *
 * Extracted verbatim from the DegreeDetail.jsx monolith (Feb 2026
 * refactor). Preserves every DOM node, class, and data-testid.
 */
import { ClusterMember } from "@/components/app/degree/ClusterLayout";
import { Section } from "@/components/app/degree/DegreeDetailBits";
import { UniLifeLink } from "@/components/app/degree/DegreeInterlinks";
import LifeAtUniBento from "@/components/app/LifeAtUniBento";
import WillYouEnjoyItCard from "@/components/app/degree/WillYouEnjoyItCard";
import SatisfactionCard from "@/components/app/SatisfactionCard";
import NssSubjectCard from "@/components/app/NssSubjectCard";
import StudentVoiceTab from "@/components/app/StudentVoiceTab";
import SubjectAggregatePanel from "@/components/app/degree/SubjectAggregatePanel";

export default function Cluster5Enjoy({ ctx }) {
  const { d, uni } = ctx;
  return (
    <ClusterMember cluster={5}>
      {/* Life at [uni] bento — six-photo grid moved from §9 Cost into
          Cluster 5 · Will you enjoy it (Feb 2026 restructure) so
          lifestyle content lives alongside the satisfaction card and
          student-voice survey. Uses `uni.gallery` when the Google
          Places seed job has populated it, else a deterministic
          per-uni pool. */}
      <LifeAtUniBento
        universityName={uni?.name}
        gallery={[
          ...(Array.isArray(uni?.gallery) ? uni.gallery : []),
          ...(uni?.photo_url ? [uni.photo_url] : []),
        ]}
        degreeId={d.id}
        universityId={d.university_id}
      />

      {/* Feb 2026 — three-essay "Will you enjoy it?" card. Data is
          generated per course by the `wua-cluster5-generator` supervisor
          job (Sonnet 4.6). Card auto-hides when the essays haven't
          been generated for this course yet, so the ~24k backlog stays
          invisible rather than showing "coming soon" placeholders. */}
      <WillYouEnjoyItCard
        degree={d}
        universityName={uni?.name}
        cityName={uni?.city}
      />

      {/* iter60 — Student satisfaction / peer review card */}
      <div className="mt-6">
        <SatisfactionCard degreeId={d.id} />
      </div>

      {/* v9.64 — First-party course-specific student survey. NSS
          subject aggregate sits in a dashed subject-panel so parents
          see it's the CAH1 cluster, not this specific course. */}
      <Section id="student-voice" title="Student Voice">
        {(d.university_id || "").startsWith("uk-") && (
          <SubjectAggregatePanel
            testId="subject-wide-context-nss"
            subjectLabel={d.subject_area || "UK subject cluster"}
            eyebrow="NSS 2025 · subject-cluster satisfaction"
            zoomOutCopy={<>how <strong>{d.subject_area || "this subject"}</strong> students nationally rate their course experience:</>}
          >
            <NssSubjectCard uniId={d.university_id} subject={d.subject_area} />
          </SubjectAggregatePanel>
        )}
        <StudentVoiceTab
          universityId={d.university_id}
          degreeId={d.id}
          courseTitle={d.title || d.name}
        />
      </Section>
      <UniLifeLink uni={uni} />
    </ClusterMember>
  );
}
